"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mkPageView = mkPageView;

var _getHasLiedOS = _interopRequireDefault(require("../Fingerprinting/getHasLiedOS"));

var _getLiedBrowser = _interopRequireDefault(require("../Fingerprinting/getLiedBrowser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function mkPageView() {
  var n = window.navigator;

  var r = function r(f) {
    try {
      var o = f();
      return _typeof(o) == _typeof(true) && o != null ? +o : o;
    } catch (e) {
      return null;
    }
  },
      ua = n.userAgent.toLowerCase(),
      re = "CSS1Compat" == document.compatMode ? document.documentElement : document.body || document.documentElement,
      pv = {
    t: "pageview",
    s: 0,
    tz: -new Date().getTimezoneOffset(),
    n: r(function () {
      return Notification.permission;
    }),
    f: r(function () {
      return window.top != window.self;
    }),
    nt: r(function () {
      var _n$connection;

      return ((_n$connection = n.connection) === null || _n$connection === void 0 ? void 0 : _n$connection.type) || null;
    }),
    ns: r(function () {
      var _n$connection2;

      return ((_n$connection2 = n.connection) === null || _n$connection2 === void 0 ? void 0 : _n$connection2.effectiveType) || null;
    }),
    l: r(function () {
      var a = window.navigator ? n.language || n.userLanguage || n.browserLanguage || n.systemLanguage : null;
      return "[object String]" == Object.prototype.toString.call(a) ? a.toLowerCase() : null;
    }),
    lz: r(function () {
      return (n.languages || []).join(" ").toLowerCase();
    }),
    vw: r(function () {
      return re.clientWidth || window.innerWidth;
    }),
    vh: r(function () {
      return re.clientHeight || window.innerHeight;
    }),
    sw: r(function () {
      return window.screen.width;
    }),
    sh: r(function () {
      return window.screen.height;
    }),
    sd: window.screen.colorDepth || null,
    sr: window.devicePixelRatio || null,
    np: r(function () {
      return n.platform || null;
    }),
    dnt: r(function () {
      if (typeof n.doNotTrack !== "undefined" && n.doNotTrack !== null) {
        if (n.doNotTrack == "yes") {
          return true;
        } else if (n.doNotTrack == "no") {
          return false;
        }

        return !!n.doNotTrack;
      } else if (typeof window.doNotTrack !== "undefined" && window.doNotTrack !== null) {
        return !!window.doNotTrack;
      }

      return null;
    }),
    c: r(function () {
      return n.cookieEnabled;
    }),
    ss: r(function () {
      return !!window.sessionStorage;
    }),
    wd: r(function () {
      return !!n.webdriver;
    }),
    ls: r(function () {
      return !!window.localStorage;
    }),
    ib: r(function () {
      return !!window.indexedDB;
    }),
    od: r(function () {
      return !!window.openDatabase;
    }),
    hf: r(function () {
      return !!document.hasFocus();
    }),
    iv: r(function () {
      return !!!document.hidden;
    }),
    ll: r(function () {
      return n.languages[0].substr(0, 2) !== n.language.substr(0, 2);
    }),
    lr: r(function () {
      return window.screen.width < window.screen.availWidth || window.screen.height < window.screen.availHeight;
    }),
    lo: r(_getHasLiedOS["default"]),
    lb: r(_getLiedBrowser["default"])
  };

  return [{
    t: "pageview",
    s: 0,
    a: pv
  }];
}